import React, { useState,useEffect } from 'react';
import { Row,Col,Card,Placeholder, Button } from 'react-bootstrap';
const PlacementVideos = ({mtId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[MiscellaneousType,setMiscellaneousType]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousType = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneousType/byId/"+mtId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneousType(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('MiscellaneousType Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneousType([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousType : Error', error.message);
            }
        };
        MiscellaneousType();
    },[mtId])
    return (
        <React.Fragment>
            {isLoading ? ( 
                <Card className=' mb-4'>
                    <Card.Header className='text-center fs-3 text-uppercase'><Placeholder xs={10} /></Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                            {[...Array(6)].map((_,index)=>(
                            <Col md={4} key={index} >
                                <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                                    <Placeholder xs={12} style={{height:"200px"}} />
                                    <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                                        <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                                        <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
            ) : (
                <React.Fragment>
                {MiscellaneousType.map((mt,index)=>(
                <Card className=' mb-4' key={index}>
                    <Card.Header className='text-center fs-3 text-uppercase'>
                        {appLanguage === 'hi' ? (mt.mt_display_en === "1" ? mt.mt_name_hi || '' : mt.mt_name_hi || mt.mt_name) : mt.mt_name}
                    </Card.Header>
                    <Card.Body>
                        <MiscellaneousList mtId={mt.mt_id} />
                    </Card.Body>
                </Card>
                ))}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}
export default PlacementVideos;
const MiscellaneousList = ({mtId}) => 
{
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByTypeAll = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                setMiscellaneous(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeAll : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeAll : Error', error.message);
            }
        };
        MiscellaneousByTypeAll();   
    },[mtId])
    
    return (
        <React.Fragment>
        {isLoading ? (
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {[...Array(6)].map((_,index)=>(
                <Col key={index}>
                    <div className="ratio ratio-4x3 border border-4 rounded" data-aos="flip-up" data-aos-duration="1000">
                        <Placeholder className="w-100 h-100" />
                    </div>
                </Col>
            ))}
            </Row>  
            ) : (
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {Miscellaneous.map((sm,index)=>(
                <Col key={index}>
                    <div className="ratio ratio-4x3 border border-4 rounded overflow-hidden" data-aos="flip-up" data-aos-duration="1000">
                        <iframe src={sm.sm_link+'?rel=0&cc_load_policy=1'} title={sm.sm_nmae} allowFullScreen></iframe>
                    </div>
                </Col>
            ))}
            </Row>
        )}
        </React.Fragment>
    );
}